import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const ShareButton = ({ stockReference }) => {
  const [shareAvailable, setShareAvailable] = useState(false);
  const [shareText, setSharedText] = useState('Share');
  useEffect(() => {
    setShareAvailable(navigator.canShare || navigator.clipboard ? true : false);
  }, []);

  const share = () => {
    const shareInfo = {
      text: 'Check out this vehicle from Arnold Clark!\n',
      url: window.location.href,
    };
    if (navigator.canShare && navigator.canShare(shareInfo)) {
      navigator.share(shareInfo).catch((error) => {
        if (window.newrelic) {
          window.newrelic.noticeError(`Product Page Error: ${error}`);
        }
      });
    } else {
      navigator.clipboard.writeText(shareInfo.url);
      setSharedText('Link copied');
    }
  };

  return (
    <button
      className={`share-button ch-btn ch-mb--2 sm:ch-display--none ${
        !shareAvailable && 'ch-display--none'
      }`}
      data-gtm-track="interaction"
      data-gtm-track-action="Clicked share link"
      data-gtm-track-label={stockReference}
      onClick={share}
      type="button"
    >
      {shareText}
    </button>
  );
};

ShareButton.propTypes = {
  stockReference: PropTypes.string,
};

export default ShareButton;
